import { create } from "zustand";

interface AppVersionState {
  /**
   * A versão que está no ar difere da do bundle desta aba (SA-1416). Só liga,
   * nunca desliga: quem zera é o reload.
   */
  updateAvailable: boolean;
  /** A versão que está no ar quando `updateAvailable` ligou. */
  deployedVersion: string | null;
  markUpdateAvailable: (deployedVersion: string) => void;
}

export const useAppVersionStore = create<AppVersionState>((set) => ({
  updateAvailable: false,
  deployedVersion: null,
  markUpdateAvailable: (deployedVersion) =>
    set({ updateAvailable: true, deployedVersion }),
}));

/** Leitura fora do React (texto de erro, reload na navegação). */
export const isAppUpdateAvailable = () =>
  useAppVersionStore.getState().updateAvailable;

/** Para onde o reload deve levar esta aba (trava contra reload em loop). */
export const getDeployedVersion = () =>
  useAppVersionStore.getState().deployedVersion;
